import styles from "./Footer.module.css";

function Footer(){
        return(
            <footer className={styles.footer}>
                <h2>DevFlix &copy; Desevolvido por Arthur Correia 2026</h2>
            </footer>
        );
}

export default Footer;